/*
  VapeHouse: barra de portes grátis (elemento <free-shipping-bar>, marcação em snippets/free-shipping-progress-bar.liquid).
  Vive num asset porque o drawer é substituído por innerHTML a cada atualização e os <script> inseridos assim não correm.
  O estado inicial vem do Liquid (data-total). Aqui:
  - ao abrir o carrinho (evento vh:cart-drawer-open) a barra carrega de 0 até ao valor, com brilho e números a contar
  - nas alterações de quantidade anima entre o valor anterior (window.__vhFreeShipping) e o novo
  - fora do drawer (página do carrinho) carrega de 0 na primeira renderização
  Respeita prefers-reduced-motion.
*/
(function () {
  if (customElements.get('free-shipping-bar')) return;

  var DURATION = 850;
  var ICON_TRUCK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 5000;
      this.fill = this.querySelector('.free-shipping-progress-bar__fill');
      this.message = this.querySelector('.free-shipping-progress-bar__message');
      this.progressText = this.querySelector('.fs-progress-text');
      if (!this.fill || !this.message || !this.progressText) return;
      this.reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      /* textos traduzidos vindos do Liquid ([amount], [total], [threshold] são substituídos aqui) */
      this.tRemaining = this.dataset.tRemaining || 'Faltam <strong class="fs-remaining">[amount]</strong> para portes grátis';
      this.tAchieved = this.dataset.tAchieved || '<strong>Portes grátis</strong> nesta encomenda';
      this.tProgress = this.dataset.tProgress || '[total] de [threshold]';
      this.msgAchieved = this.classList.contains('free-shipping-progress-bar--achieved');
      this.remainingEl = this.message.querySelector('.fs-remaining');
      this.animStart = 0;

      var previous = window.__vhFreeShipping || null;
      var initial = parseInt(this.dataset.total, 10);
      this.total = isNaN(initial) ? null : initial;
      var drawerEl = this.closest('cart-drawer');
      var drawerClosed = !!(drawerEl && !drawerEl.classList.contains('active'));

      if (this.total === null) {
        this.refresh();
      } else if (drawerClosed) {
        /* o drawer está escondido: fica no estado final sem animar; a abertura (vh:cart-drawer-open) faz o 0 → valor */
        this.apply(this.total, null, false);
      } else if (!previous) {
        /* primeira vez nesta página (ex.: página do carrinho): carrega de 0 */
        this.apply(this.total, { total: 0 }, true);
      } else if (previous.total !== this.total || previous.shown != null) {
        /* elemento acabado de substituir depois de uma alteração: parte do valor que estava no ecrã */
        this.apply(this.total, previous, false);
      } else {
        this.apply(this.total, null, false);
      }
      this.bind();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('cart:updated', this.onExternal);
      document.removeEventListener('vh:cart-drawer-open', this.onOpen);
      if (this.raf) cancelAnimationFrame(this.raf);
      clearTimeout(this.animTimer);
      clearTimeout(this.openTimer);
    }

    bind() {
      var self = this;
      this.onExternal = function () { self.refresh(); };
      document.addEventListener('cart:updated', this.onExternal);
      /* o carrinho vai abrir (o evento chega antes de o painel ficar visível): põe a barra a 0 já,
         e começa a encher quando o painel já deslizou (260 ms) */
      this.onOpen = function () {
        if (self.total === null || !self.isConnected || !self.closest('cart-drawer')) return;
        self.resetToZero();
        clearTimeout(self.openTimer);
        self.openTimer = setTimeout(function () {
          if (self.isConnected) self.apply(self.total, { total: 0 }, true);
        }, 260);
      };
      document.addEventListener('vh:cart-drawer-open', this.onOpen);
      var trySubscribe = function (attempt) {
        if (!self.isConnected) return;
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          self.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (event && event.cartData && typeof event.cartData.total_price === 'number') {
              self.update(event.cartData.total_price);
            } else {
              self.refresh();
            }
          });
        } else if (attempt < 20) {
          setTimeout(function () { trySubscribe(attempt + 1); }, 100);
        }
      };
      trySubscribe(0);
    }

    formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    percentFor(total) {
      var p = Math.min((total / this.threshold) * 100, 100);
      if (total > 0 && p < 2) p = 2;
      return p;
    }

    refresh() {
      var self = this;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (self.isConnected) self.update(cart.total_price); })
        .catch(function () {});
    }

    /* estado vazio imediato e sem transição (usado no instante em que o drawer vai abrir) */
    resetToZero() {
      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
      clearTimeout(this.animTimer);
      this.fill.classList.remove('vh-fs-animating');
      this.fill.style.transition = 'none';
      this.fill.style.width = '0%';
      this.fill.getBoundingClientRect();
      this.fill.style.transition = '';
      this.setTexts(0, this.threshold);
    }

    /* valor novo vindo de um evento (o elemento não foi substituído) */
    update(total) {
      if (typeof total !== 'number') return;
      /* o elemento já reflete este valor (acabou de ser renderizado): não interromper a animação em curso */
      if (total === this.total) return;
      var from = { total: this.total === null ? 0 : this.total };
      this.total = total;
      this.apply(total, from, false);
    }

    apply(total, from, force) {
      var self = this;
      var percent = this.percentFor(total);
      var remaining = Math.max(this.threshold - total, 0);
      var achieved = remaining <= 0;
      var animate = !!from && !this.reduceMotion && (force || from.total !== total);

      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
      clearTimeout(this.animTimer);

      if (animate) {
        /* se a barra anterior foi substituída a meio de uma animação, parte do valor que estava no ecrã */
        var fromTotal = from.shown != null ? from.shown : from.total;
        /* a barra segue uma curva CSS diferente da contagem: partir da largura que estava mesmo desenhada */
        var fromPercent = from.shownPercent != null ? from.shownPercent : this.percentFor(fromTotal);
        /* textos e barra no valor de partida já neste frame (o Liquid trazia o valor final) */
        this.setTexts(fromTotal, Math.max(this.threshold - fromTotal, 0));
        this.fill.style.transition = 'none';
        this.fill.style.width = fromPercent + '%';
        this.fill.getBoundingClientRect();
        this.fill.style.transition = '';
        this.fill.classList.remove('vh-fs-animating');
        void this.fill.offsetWidth;
        this.fill.classList.add('vh-fs-animating');
        this.animStart = performance.now();
        requestAnimationFrame(function () { self.fill.style.width = percent + '%'; });
        this.countUp(fromTotal, total);
        this.animTimer = setTimeout(function () { self.fill.classList.remove('vh-fs-animating'); }, DURATION + 900);
      } else {
        this.fill.style.width = percent + '%';
        this.setTexts(total, remaining);
      }

      window.__vhFreeShipping = { percent: percent, total: total };
    }

    /* números a contar do valor anterior até ao novo, ao ritmo da barra */
    countUp(fromTotal, toTotal) {
      var self = this;
      var start = performance.now();
      var step = function (now) {
        /* o timestamp do rAF pode ser anterior ao performance.now() da chamada: nunca deixar t negativo */
        var t = Math.max(0, Math.min((now - start) / DURATION, 1));
        var value = Math.round(fromTotal + (toTotal - fromTotal) * easeOutCubic(t));
        self.setTexts(value, Math.max(self.threshold - value, 0));
        if (window.__vhFreeShipping) {
          window.__vhFreeShipping.shown = t < 1 ? value : null;
          var track = self.fill.parentElement;
          var tw = track ? track.getBoundingClientRect().width : 0;
          window.__vhFreeShipping.shownPercent = t < 1 && tw > 0 ? (self.fill.getBoundingClientRect().width / tw) * 100 : null;
        }
        if (t < 1) self.raf = requestAnimationFrame(step); else self.raf = null;
      };
      this.raf = requestAnimationFrame(step);
    }

    setTexts(total, remaining) {
      var achieved = remaining <= 0;
      /* a cor verde entra no instante em que a contagem cruza os 50 €, não no início da animação */
      this.classList.toggle('free-shipping-progress-bar--achieved', achieved);
      if (achieved !== this.msgAchieved) {
        this.message.innerHTML = achieved
          ? ICON_CHECK + '<span>' + this.tAchieved + '</span>'
          : ICON_TRUCK + '<span>' + this.tRemaining.replace('[amount]', this.formatMoney(remaining)) + '</span>';
        this.msgAchieved = achieved;
        this.remainingEl = this.message.querySelector('.fs-remaining');
        if (!this.reduceMotion) {
          this.message.classList.remove('vh-fs-swap');
          void this.message.offsetWidth;
          this.message.classList.add('vh-fs-swap');
        }
      }
      if (!achieved) {
        if (this.remainingEl) this.remainingEl.textContent = this.formatMoney(remaining);
        else this.message.innerHTML = ICON_TRUCK + '<span>' + this.tRemaining.replace('[amount]', this.formatMoney(remaining)) + '</span>';
      }
      this.progressText.textContent = this.tProgress.replace('[total]', this.formatMoney(total)).replace('[threshold]', this.formatMoney(this.threshold));
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);

  /* mantém o valor partilhado atualizado mesmo quando não há barra (ex.: carrinho esvaziado),
     para a barra seguinte não arrancar de um total antigo */
  (function bindGlobal(attempt) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.total_price === 'number') {
          var t = event.cartData.total_price;
          var p = Math.min((t / 5000) * 100, 100);
          if (t > 0 && p < 2) p = 2;
          window.__vhFreeShipping = { percent: p, total: t };
        }
      });
    } else if (attempt < 30) {
      setTimeout(function () { bindGlobal(attempt + 1); }, 100);
    }
  })(0);
})();
